import 'sass/app.scss'

import 'js/helpers/compatibility';
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueTransferDom from 'js/helpers/vue-transfer-dom';
import VueAlerter from 'js/helpers/vue-alerter';
import store from 'js/vuex/store';
import router from 'js/router';
import track from 'js/helpers/analytics';

import Main from 'js/components/Main.vue';
import Loading from 'js/components/elements/Loading.vue'

// make sure tracking function is available before router starts
track.init(document.body.dataset.analyticsId)

// register global error handler
window.onerror = function (message, file, line, col, error) {
    track.exception('Uncaptured: ' + message + ' on ' + file + ':' + line + '-' + col, error)
}

if (process.env.NODE_ENV === 'production') {

    Raven
        .config(document.body.dataset.sentryDsn, {
            release: document.body.dataset.release,
        })
        .addPlugin(RavenVue, Vue)
        .install();

}

Vue.use(VueTransferDom)
Vue.use(VueAlerter)
Vue.component('loading', Loading)

new Vue({
    router,
    store,
    el: '#app',
    render: h => h(Main)
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js